import { jsx } from 'react/jsx-runtime';
import React__default, { useContext, useMemo } from 'react';

const hintContext = React__default.createContext({ defaultHintDuration: 'slow' });
const HintProvider = ({ defaultHintDuration = 'slow', children }) => {
    return jsx(hintContext.Provider, Object.assign({ value: { defaultHintDuration } }, { children: children }));
};
const DURATIONS = {
    slow: { enter: 1700, leave: 100 },
    fast: { enter: 400, leave: 100 },
    immediate: { enter: 0, leave: 0 },
};
const useHintDuration = ({ duration, enterDelay, leaveDelay, clickable }) => {
    const { defaultHintDuration } = useContext(hintContext);
    return useMemo(() => {
        if (clickable) {
            return DURATIONS.immediate;
        }
        const selectedDuration = DURATIONS[duration || defaultHintDuration];
        const enter = typeof enterDelay === 'number' && enterDelay >= 0 ? enterDelay : selectedDuration.enter;
        const leave = typeof leaveDelay === 'number' && leaveDelay >= 0 ? leaveDelay : selectedDuration.leave;
        return { enter, leave };
    }, [duration, clickable, defaultHintDuration, enterDelay, leaveDelay]);
};

export { HintProvider, useHintDuration };
//# sourceMappingURL=HintProvider.js.map
